// Fonction de nettoyage de texte
export const sanitizeInput = (input: string, mode: string): string => {
  // Retire les balises <script> et leur contenu
  let sanitized = input.replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '');
  // Retire les autres balises HTML
  sanitized = sanitized.replace(/<[^>]*>?/gm, '');
  // Retire les caractères spéciaux non autorisés
  sanitized = sanitized.replace(
    mode === 'strict'
      ? /[^a-zA-Z0-9À-ÿ '-]/g
      : /[^a-zA-Z0-9À-ÿ '_@.-]/g,
    ''
  );
  return sanitized.trim();
};

export const isAnEmail = (value: string): boolean =>
    /^[^\s@]{1,64}@[^\s@]{1,255}\.[^\s@]{2,10}$/.test(value.trim());